import { createContext, useContext } from "react";

interface AuthLoadingContextType {
    setAuthLoading: (isLoading: boolean) => void;
    isAuthLoading: boolean;
}

export const AuthLoadingContext = createContext<AuthLoadingContextType | null>(null);

export const useAuthLoading = () => {
    const context = useContext(AuthLoadingContext);
    if (!context) {
        throw new Error("useAuthLoading must be used within an AuthLoadingContext.Provider");
    }
    return context;
};